import React, { useState, useRef } from "react";

import styles from "./TextArea.module.scss";

interface IProps {
    label: string,
    placeholder: string,
    disabled?: boolean,
    defaultValue?: string,
    className?: string,
    onChange(e: React.ChangeEvent<HTMLTextAreaElement>): void
}

const TextArea: React.FC<IProps> = (props) => {
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const inputRef = useRef<HTMLTextAreaElement>(null);

    const setFocus = () => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
            setIsFocused(true);
        }
    }

    const onBlur = () => {
        setIsFocused(false);
    }

    const wrapperClassName = [styles.TextArea, isFocused ? styles.focused : "", props.className || ""].filter(Boolean).join(" ");

    return (
        <div onClick={() => { if (!props.disabled) { setFocus(); } }} className={wrapperClassName}>
            <label><span>{props.label}</span></label>
            <textarea
                defaultValue={props.defaultValue ?? undefined}
                ref={inputRef}
                onBlur={onBlur}
                placeholder={props.placeholder}
                onChange={props.onChange}
            >
            </textarea>
        </div>
    );
};

export default TextArea;